import { NgModule, ModuleWithProviders } from '@angular/core';
import { NumberHelperService } from './numer-helper.service';


@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class NumberHelperModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: NumberHelperModule,
            providers: [
                NumberHelperService
            ]
        };
    }
}
